import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import ResourceGrid from "../components/ResourceGrid";
//import PreviewCompatibleImage from "../components/PreviewCompatibleImage";

export const ResourcesPageTemplate = ({
  image,
  title,
  heading,
  description,
  new_appliances,
  used,
  repair,
  service,
  disposal
}) => (
  <div className="content">
    <div
      className="full-width-image-container margin-top-0"
      style={{
        backgroundImage: `url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`
      }}
    >
      <h2
        className="has-text-weight-bold is-size-1"
        style={{
          color: "white",
          padding: "1rem"
        }}
      >
        {title}
      </h2>
    </div>
    <div className="container">
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h3 className="has-text-weight-semibold is-size-2">{heading}</h3>
          <p>{description}</p>
        </div>
      </div>
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2 className="has-text-weight-semibold is-size-2">
            {new_appliances.heading}
          </h2>
          <ResourceGrid
            gridItems={new_appliances ? new_appliances.blurbs : []}
          />
        </div>
      </div>
      <div className="is-divider"></div>
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2 className="has-text-weight-semibold is-size-2">{used.heading}</h2>
          <ResourceGrid gridItems={used ? used.blurbs : []} />
        </div>
      </div>
      <div className="is-divider"></div>
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2 className="has-text-weight-semibold is-size-2">
            {repair.heading}
          </h2>
          <ResourceGrid gridItems={repair ? repair.blurbs : []} />
        </div>
      </div>
      <div className="is-divider"></div>
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2 className="has-text-weight-semibold is-size-2">
            {service.heading}
          </h2>
          <ResourceGrid gridItems={service ? service.blurbs : []} />
        </div>
      </div>
      <div className="is-divider"></div>
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2 className="has-text-weight-semibold is-size-2">
            {disposal.heading}
          </h2>
          <ResourceGrid gridItems={disposal ? disposal.blurbs : []} />
        </div>
      </div>
    </div>
  </div>
);

ResourcesPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  new_appliances: PropTypes.shape({
    blurbs: PropTypes.array
  }),
  used: PropTypes.shape({
    blurbs: PropTypes.array
  }),
  repair: PropTypes.shape({
    blurbs: PropTypes.array
  }),
  service: PropTypes.shape({
    blurbs: PropTypes.array
  }),
  disposal: PropTypes.shape({
    blurbs: PropTypes.array
  })
};

const ResourcesPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout>
      <ResourcesPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        description={frontmatter.description}
        new_appliances={frontmatter.new_appliances}
        used={frontmatter.used}
        repair={frontmatter.repair}
        service={frontmatter.service}
        disposal={frontmatter.disposal}
      />
    </Layout>
  );
};

ResourcesPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object
    })
  })
};

export default ResourcesPage;

export const resourcesPageQuery = graphql`
  query ProductPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 4096, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        description
        new_appliances {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
            link
            title
          }
          heading
        }
        used {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
            link
            title
          }
          heading
        }
        repair {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
            link
            title
          }
          heading
        }
        service {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
            link
            title
          }
          heading
        }
        disposal {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
            link
            title
          }
          heading
        }
      }
    }
  }
`;
